<div class="listing-container">

  <!-- Header Button -->
  <div class="header-section">
    <button class="btn-create" (click)="createNewAssignment()">
      New Assignment
    </button>
  </div>

  <div class="content-section">

    <h2 class="page-title">Survey Assignments</h2>

    <!-- Error -->
    <div *ngIf="error && dataLoaded" class="no-data">
      {{ error }}
    </div>

    <!-- Empty -->
    <div *ngIf="dataLoaded && !error && assignments.length === 0" class="no-data">
      No Assignments Found
    </div>

    <!-- Table -->
    <div *ngIf="!error && assignments.length > 0" class="table-container">
      <table class="data-table">

        <thead>
          <tr>
            <th>Survey Name</th>
            <th>Assigned Employee</th>
            <th>Assigned Customers</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let assignment of assignments"
            (click)="viewAssignmentDetail(assignment.survey_id)"
          >
            <td>{{ assignment.survey_title }}</td>
            <td>{{ assignment.employee_name }}</td>
            <td>{{ assignment.customer_count }}</td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
</div>
